import React from "react";
import { useForm } from "react-hook-form";
import { updateDb } from "../services/updateDb";

import { useNavigate } from "react-router-dom";

import OrganizationForm from "./OrganizationForm";
import { useAppContext } from "../AppContext";
import { useTranslation } from "react-i18next";

const AddOrganizationPage = () => {
  const { t } = useTranslation();
  const { currentUser, triggerHeaderRefresh } = useAppContext();
  const navigate = useNavigate();
  const { register, handleSubmit, setValue } = useForm();
  const onSubmit = async (data) => {
    let orgObj = {
      name: data.name,
      ownerUserId: data.ownerUserId,
      description: data.description,
      securityStandard: data.securityStandard,
      rangeBounds: data.rangeBounds.split(',').map(Number)
    };

    const res = await updateDb("/api/organizations/", orgObj);

    if (res.success) {
      triggerHeaderRefresh();
      navigate("/organizations", { state: { message: t('organization') + " " + t('added'), type: "success" } });
    }
  };

  return (
    <div id="content">
      <div id="content-title">{t('add_organization')}</div>

      <div className="content-bubble">
        <OrganizationForm
          register={register}
          handleSubmit={handleSubmit}
          currentUser={currentUser}
          onSubmit={onSubmit}
          text={t('add_organization')}
          setValue={setValue}
        />
      </div>
    </div>
  );
};

export default AddOrganizationPage;
